module.exports = __webpack_public_path__ + "media/images/map_icons/Baseball-e5ec083470c3e6b9a18540908be2e7a8.svg";